module.exports = __webpack_public_path__ + "static/media/enpic_RazitkoPLKulate.5def240e.png";